import React from 'react';
import './small-loader.styles.scss';

function SmallLoader() {
  return <div className="small-loader">Loading...</div>;
}

export default SmallLoader;
